module.exports = __webpack_public_path__ + "img/icon-contact.ff04febf.svg";